import { AccountType } from "@/modules/account/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getAccountTabItems = ({ t }: ITabItemsProps) => [
  {
    value: AccountType.SettlementAccount,
    label: t("accounts.currentAccounts"),
    dataId: "account-tab",
    disabled: false,
  },
  {
    value: AccountType.CardAccount,
    label: t("accounts.cardAccounts"),
    dataId: "card-account-tab",
    disabled: false,
  },
  {
    value: AccountType.ClosedAccount,
    label: t("accounts.closedAccounts"),
    dataId: "closed-account-tab",
    disabled: false,
  }];
